import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SignInState {
  user: { id: string; name: string } | null;
  token: string | null;
  status: "idle" | "loading" | "error";
  isLoggedIn: boolean;
}

const initialState: SignInState = {
  user: null,
  token: null,
  status: "idle",
  isLoggedIn: true,
};

const welcomeSlice = createSlice({
  name: "signIn",
  initialState,
  reducers: {
    loginStart(state) {
      state.status = "loading";
    },
    loginSuccess(
      state,
      action: PayloadAction<{ user: SignInState["user"]; token: string }>
    ) {
      state.status = "idle";
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isLoggedIn = true;
    },
    loginFailure(state) {
      state.status = "error";
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.status = "idle";
      state.isLoggedIn = false;
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout } =
  welcomeSlice.actions;
export default welcomeSlice.reducer;
